import { selectSalesIntelligenceState } from "app/pages/sales-intelligence/store/selectors";
import { createStatePropertySelector } from "app/pages/workspace/sales/helpers";

import type { QuotaState } from "./types";

const selectQuotaState = createStatePropertySelector<QuotaState>(selectSalesIntelligenceState("quota"));

export const selectIsDataCostVisible = selectQuotaState("isDataCostVisible");
export const selectIsDataCreditsModalOpen = selectQuotaState("isDataCreditsModalOpen");
export const selectIsQuotaContactAdminModalOpen = selectQuotaState("isQuotaContactAdminModalOpen");
